import {
    GoogleReCaptchaProvider,
    GoogleReCaptcha,
} from 'react-google-recaptcha-v3';
import enviroment from '../../../enviroments/enviroment';

interface IRecaptcha {
    children: any;
}

const Recaptcha = ({ children }: IRecaptcha) => {
    const onVerify = () => {};
    return (
        <GoogleReCaptchaProvider
            language="es"
            reCaptchaKey={enviroment.reCaptcha}
            useRecaptchaNet={true}
        >
            {children}
            <GoogleReCaptcha onVerify={onVerify} />
        </GoogleReCaptchaProvider>
    );
};

export default Recaptcha;
